import { render } from "./xtx-more.vue?vue&type=template&id=60eeae18&scoped=true"
import script from "./xtx-more.vue?vue&type=script&lang=js"
export * from "./xtx-more.vue?vue&type=script&lang=js"

import "./xtx-more.vue?vue&type=style&index=0&id=60eeae18&scoped=true&lang=less"

import exportComponent from "F:\\workspan\\java\\lhc\\hk-lottery-lhc-ui\\hk-lottery-lhc-pc-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60eeae18"]])

export default __exports__